import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  palette: {
    primary: { main: '#0c91c4' },
    secondary: { main: '#bbd631' },
    text: { white: '#e3e3e3' },
  },
  typography: {
    h5: {
      fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", "sans-serif"',
    },
    body2: {
      fontWeight: 600,
      color: '#333',
    },
  },
  overrides: {
    MuiInput: {
      root: {
        '&$disabled': {
          color: 'inherit !important',
        },
      },
    },
  },
});
